import { Config } from "../../types";

export * from "./SensorSort";
export * from "./SensorPublished";
export * from "./SensorCollection";
export * from "./SensorSearchTerm";
export * from "./SensorInventoryAvailable";

export * from "./Sensors";

// this is consumed by the react prop in various components
export const SENSOR_IDS = (mode: "search" | "collection" | "instant-search", config: Config) => {
  const sensorIds = [
    "SensorSort",
    "SensorPublished",
    "SensorCollection",
    "SensorSearchTerm",
    "SensorInventoryAvailable",
  ];
  const customSensors = mode === "collection" ? config.sensors.collection : config.sensors.search;
  if (customSensors.length > 0) {
    sensorIds.push(...customSensors.map((item, index) => `SensorCustom_${index}`));
  }

  return sensorIds;
}